import React from 'react';
import gql from 'graphql-tag';
import useQuery from '../../../../../modules/react/hooks/useQuery';
import Container from '../components/Container';

const GET_BLOG_DATA = gql`
  query GetCurrentSiteBlogData {
    currentSite {
      id
      ...CurrentSiteBlogDataContainer
    }
  }

  ${Container.fragments.currentSite}
`;

const propTypes = {};
const defaultProps = {};

const BlogContainer = (props) => {
  const { data } = useQuery(GET_BLOG_DATA);

  if (!data) {
    return null;
  }

  return (
    <Container
      {...props}
      site={data.currentSite}
    />
  );
};

BlogContainer.propTypes = propTypes;
BlogContainer.defaultProps = defaultProps;

BlogContainer.fragments = {};

export default BlogContainer;
